import { useContext, useEffect, useState } from "react";
import { Button, Input } from "reactstrap";

import "../../styles/DataSheetAdmin.css";

import { RestContext } from "../../App";
import { SITE_URL } from "../../serverConfig";
import SortControls from "../../components/SortControls";

function DataSheetAdmin({}) {
	const [columns, setColumns] = useState([]);
	const [changed, setChanged] = useState(false);

	const { sendGetRequest, sendPostRequest } = useContext(RestContext);

	useEffect(() => {
		sendGetRequest(SITE_URL + "/sheet/columns", (response) => {
			setColumns(response.data);
			setChanged(false);
		});
	}, []);

	const swapColumns = (oldIndex, newIndex) => {
		if (
			oldIndex < 0 ||
			newIndex < 0 ||
			oldIndex >= columns.length ||
			newIndex >= columns.length
		)
			return;
		const newColumns = [...columns];
		const tmp = columns[oldIndex];
		newColumns[oldIndex] = columns[newIndex];
		newColumns[newIndex] = tmp;
		setColumns(newColumns);
        setChanged(true);
	};

	const canSubmit = () => {
		return changed && !columns.some((column) => !column.length);
	};

	const mapColumns = () => {
		return columns.map((column, index) => (
			<div className="data-sheet-admin-list-item">
				<SortControls size="sm" index={index} updateFn={swapColumns} />
				<Input
                    className="data-sheet-admin-column-input"
					type="text"
					maxLength={100}
					value={column[0]}
					onChange={(event) => {
						const value = event.target.value;
						const newColumns = [...columns];
						newColumns[index][0] = value;
						setColumns(newColumns);
						setChanged(true);
					}}
				/>
				<Input
                    className="data-sheet-admin-keyword-input"
					type="text"
					maxLength={100}
                    placeholder="Google Maps keyword..."
					value={column[1]}
					onChange={(event) => {
						const value = event.target.value;
						const newColumns = [...columns];
						newColumns[index][1] = value;
						setColumns(newColumns);
						setChanged(true);
					}}
				/>
			</div>
		));
	};

	const handleSubmit = () => {
		sendPostRequest(SITE_URL + "/sheet/columns", columns, (response) => {
			setChanged(false);
		});
	};

	return (
		<div id="data-sheet-admin">
            <h3>Data Sheet Columns</h3>
			<div id="data-sheet-admin-list">{mapColumns()}</div>
			<Button
				id="data-sheet-admin-submit"
				className="submit"
				onClick={handleSubmit}
				disabled={!canSubmit()}
			>
				Save
			</Button>
		</div>
	);
}

export default DataSheetAdmin;
